import { Method } from "../../data/DataUtils.js";
import * as DataUtils from "../../data/DataUtils.js";
import * as DTOs from "../DTOs/ClubNombresDTOs.js";

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    "clubes/" + idPadre + "/nombres/" + idItem,
    null
  );
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject("clubes/" + idPadre + "/nombres/" + idItem);
};

export const GetListaItems = async (idPadre) => {
  return DataUtils.FetchLista("clubes/" + idPadre + "/nombres");
};

export const PostItem = async (idPadre, datosItem) => {
  return await DataUtils.SaveObject(
    Method.POST,
    "clubes/" + idPadre + "/nombres",
    DTOs.saveItem(datosItem)
  );
};

export const PutItem = async (idPadre, datosItem) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    "clubes/" + idPadre + "/nombres/" + datosItem.id,
    DTOs.saveItem(datosItem)
  );
};
